<template>
  <div>
    <div class="index-left-bottom">
      <el-tabs v-model="activeName">
        <el-tab-pane label="充值记录" name="first" style="height:100%">
          <el-table :data="QueryHistoryMoneyTransfers" style="width: 100%" v-loading="loading" width="100%" height="calc(100% - 100px)">
             <el-table-column type="index" label="序号">
              </el-table-column>
            <el-table-column prop="TransferMoney" :label="'充值金额('+ CurrencyName +')'">
            </el-table-column>
            <el-table-column prop="TransferMoneyFact" :label="'实到金额('+ CurrencyName +')'">
            </el-table-column>
            <el-table-column prop="Id" label="交易号">
            </el-table-column>
            <el-table-column prop="AddDate" label="创建日期">
            </el-table-column>
            <el-table-column prop="OrderState" label="状态">
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
              </template>
            </el-table-column>
            <el-dialog title="查看详情" :visible.sync="dialogVisible" append-to-body width="80%">
              <div class="infobox clearfix">
                  <div class="infoboxinfo">
                      <span>充值金额:</span>
                      <input type="text" v-model="obj.TransferMoney"  disabled>
                  </div>
                  <div class="infoboxinfo">
                      <span>交易号:</span>
                      <input type="text" v-model="obj.Id"  disabled>
                  </div>
                  <div class="infoboxinfo">
                      <span>创建日期:</span>
                      <input type="text" v-model="obj.AddDate"  disabled>
                  </div>
                  <div class="infoboxinfo">
                      <span>状态:</span>
                      <input type="text" v-model="obj.OrderState"  disabled>
                  </div>
                  <div class="infoboxinfo">
                      <span>汇率:</span>
                      <input type="text" v-model="obj.ExchangeRate"  disabled>
                  </div>
                  <div class="infoboxinfo">
                      <span>实到{{CurrencyName}}:</span>
                      <input type="text" v-model="obj.TransferMoneyFact"  disabled>
                  </div>
                  <div class="infoboxinfo">
                      <span>实到:</span>
                      <input type="text" v-model="obj.LocalMoneyFact"  disabled>
                  </div>
                  <div class="infoboxinfo">
                      <span>{{CurrencyName}}手续费:</span>
                      <input type="text" v-model="obj.TransferMoneyFee"  disabled>
                  </div>
                  <div class="infoboxinfo">
                      <span>手续费:</span>
                      <input type="text" v-model="obj.LocalMoneyFee"  disabled>
                  </div>
              </div>
              <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
              </span>
            </el-dialog>
          </el-table>
          <div class="pagination_m text-center">
            <pagination :pagerPro="Pager1" @ee="pageFn1"></pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane label="提现记录" name="second" style="height:100%">
          <el-table :data="withdrawList" style="width: 100%" v-loading="loading" width="100%" height="calc(100% - 100px)">
             <el-table-column type="index" label="序号">
              </el-table-column>
            <el-table-column prop="TransferMoney" :label="'提现金额('+ CurrencyName +')'">
            </el-table-column>
            <el-table-column prop="TransferMoneyFact" :label="'实到金额('+ CurrencyName +')'">
            </el-table-column>
            <el-table-column prop="Id" label="交易号">
            </el-table-column>
            <el-table-column prop="AddDate" label="创建日期">
            </el-table-column>
            <el-table-column prop="OrderState" label="状态">
            </el-table-column>
             <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button @click="handleClick2(scope.row)" type="text" size="small">查看</el-button>
              </template>
            </el-table-column>
            <el-dialog title="查看详情" :visible.sync="dialogVisible2" append-to-body width="80%">
              <div class="infobox clearfix">
                  <div class="infoboxinfo">
                      <span>提现金额:</span>
                      <input type="text" v-model="obj2.TransferMoney"  disabled>
                  </div>
                  <div class="infoboxinfo">
                      <span>交易号:</span>
                      <input type="text" v-model="obj2.Id"  disabled>
                  </div>
                  <div class="infoboxinfo">
                      <span>创建日期:</span>
                      <input type="text" v-model="obj2.AddDate"  disabled>
                  </div>
                  <div class="infoboxinfo">
                      <span>状态:</span>
                      <input type="text" v-model="obj2.OrderState"  disabled>
                  </div>
                  <div class="infoboxinfo">
                      <span>汇率:</span>
                      <input type="text" v-model="obj2.ExchangeRate"  disabled>
                  </div>
                  <div class="infoboxinfo">
                      <span>实到{{CurrencyName}}:</span>
                      <input type="text" v-model="obj2.TransferMoneyFact"  disabled>
                  </div>
                  <div class="infoboxinfo">
                      <span>实到:</span>
                      <input type="text" v-model="obj2.LocalMoneyFact"  disabled>
                  </div>
                  <!-- <div class="infoboxinfo">
                      <span>{{CurrencyName}}手续费:</span>
                      <input type="text" v-model="obj2.TransferMoneyFee"  disabled>
                  </div>
                  <div class="infoboxinfo">
                      <span>人民币手续费:</span>
                      <input type="text" v-model="obj2.LocalMoneyFee"  disabled>
                  </div> -->
              </div>
              <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible2 = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisible2 = false">确 定</el-button>
              </span>
            </el-dialog>
          </el-table>
          <div class="pagination_m text-center">
            <pagination :pagerPro="Pager2" @ee="pageFn2"></pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div class="historyline"></div>

    </div>
  </div>
</template>

<script>
import "../assets/lib/jquery.min.js";
import pagination from "./paging.vue";

export default {
  name: "history",
  components: {
    pagination
  },
  data() {
    return {
      loading: "",
      dialogVisible: false,
      obj: {},
      dialogVisible2: false,
      obj2: {},
      activeName: "first",
      rechargerecord: [],
      QueryHistoryMoneyTransfers: [],
      withdrawList: [],
      currDate: "",
      YearsAgo: "",
      Pager1: {
        PageNo: 1,
        PageSize: 20,
        RecordCount: 0
      },
      Pager2: {
        PageNo: 1,
        PageSize: 20,
        RecordCount: 0
      },
      CurrencyName: '',
    };
  },
  mounted() {},
  created() {
    this.currDate = new Date();
    let Year = this.currDate.getFullYear() - 1;
    let currMonth = this.currDate.getMonth() + 1;
    let currDate = this.currDate.getDate();
    this.YearsAgo = Year + "-" + currMonth + "-" + currDate;
    this.QueryHistoryMoneyTransfer();
    this.getWithdrawList();
    this.getCurrencyName();
  },
  methods: {
    getCurrencyName() {
      var url = "/Account/GetInsBasicCurrency";
      var post = "";
      this.$loginapi.post(url, post, response => {
        if (response.Ret == 0) {
          this.CurrencyName = response.Data.Name;
        } else {
          this.$alert(response.Msg, {});
        }
      });
    },
    pageFn1(size, PageNo) {
      this.Pager1.PageSize = size;
      this.Pager1.PageNo = PageNo;
      this.QueryHistoryMoneyTransfer();
    },
    pageFn2(size, PageNo) {
      this.Pager2.PageSize = size;
      this.Pager2.PageNo = PageNo;
      this.getWithdrawList();
    },
    //充值记录
    QueryHistoryMoneyTransfer() {
      this.loading = true;
      let url = "/report/QueryHistoryMoneyTransfer";
      let postData = {
        MoneyTransType: 1,
        BeginDate: this.YearsAgo,
        EndDate: this.currDate
      };
      this.$loginapi.postWithPage(
        url,
        this.Pager1.PageNo,
        this.Pager1.PageSize,
        postData,
        response => {
          this.loading = false;
          if (response.Ret == 0) {
            this.QueryHistoryMoneyTransfers = response.Data;
            if (this.Pager1.PageNo == 1) {
              this.Pager1 = response.Pager;
            }
          } else {
            this.$message.error(response.Msg);
          }
        }
      );
    },
    //提现记录
    getWithdrawList() {
      this.loading = true;
      let url = "/report/QueryHistoryMoneyTransfer";
      let postData = {
        MoneyTransType: 2,
        BeginDate: this.YearsAgo,
        EndDate: this.currDate
      };
      this.$loginapi.postWithPage(
        url,
        this.Pager2.PageNo,
        this.Pager2.PageSize,
        postData,
        response => {
          this.loading = false;
          if (response.Ret == 0) {
            this.withdrawList = response.Data;
            if (this.Pager2.PageNo == 1) {
              this.Pager2 = response.Pager;
            }
          } else {
            this.$message.error(response.Msg);
          }
        }
      );
    },
    handleClick(row){
      this.obj = row;
      this.dialogVisible = true;
    },
    handleClick2(row){
      this.obj2 = row;
      this.dialogVisible2 = true;
    }
  }
};
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/history.vue